import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("구매 신청된 상태입니다 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 구매금 입금을 하시거나, 구매 신청을 취소하셔야")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 새로운 구매가 가능합니다. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('입금계좌'))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('입금 금액'))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('입금 가능 기한'))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 구매 취소하기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    height: "auto",
    "safe-area": true,
    "swipe-to-close": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, { handle: true }),
      _createVNode(_component_modal_header, {
        title: "조합지분 구매 정보",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDepositModal')))
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            p: "8px 20px 0px 20px",
            dp: "flex",
            direction: "column",
            "justify-content": "space-between"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, {
                m: "8px 0px",
                "font-weight": "bold",
                "font-size": "18px",
                "text-align": "center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.depositRef.partnershipName) + " 매물", 1),
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                m: "8px 0px",
                "font-size": "14px",
                "text-align": "center",
                color: "#5E6068"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "14px",
                mt: "20px",
                "line-height": "22px",
                color: "#8F929B"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "16px",
                "font-weight": "bold",
                "line-height": "22px",
                color: "#222222"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.depositRef.bank) + " " + _toDisplayString(_ctx.depositRef.virtualAccount) + " " + _toDisplayString(_ctx.depositRef.virtualAccountOwner), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "14px",
                mt: "20px",
                "line-height": "22px",
                color: "#8F929B"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "16px",
                "font-weight": "bold",
                "line-height": "22px",
                color: "#222222"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.depositRef.buyerClaim)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "14px",
                mt: "20px",
                "line-height": "22px",
                color: "#8F929B"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, {
                "font-size": "16px",
                "font-weight": "bold",
                "line-height": "22px",
                color: "#222222"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.remainingSeconds), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_footer, {
            p: "20px",
            mb: "safeAreaBottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                corner: '10px',
                outline: "primary",
                width: '100%',
                onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelToBuy()))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}